var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDouble2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H25C29.4183 0 33 3.58172 33 8V20C33 24.4183 29.4183 28 25 28H8C3.58172 28 0 24.4183 0 20V8Z",
    fill: "url(#paint0_linear_1_1109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32884 10.0909L10.1257 13.6847L11.9865 10.0909H15.4879L12.4411 15.5455L15.6016 21H12.1286L10.1257 17.3778L8.17259 21H4.64986L7.81747 15.5455L4.80611 10.0909H8.32884ZM17.0451 21V18.4716L22.3505 13.8267C22.7482 13.4669 23.0868 13.1378 23.3661 12.8395C23.6455 12.5365 23.8585 12.2334 24.0053 11.9304C24.1521 11.6226 24.2255 11.2888 24.2255 10.929C24.2255 10.5265 24.1379 10.1832 23.9627 9.89915C23.7875 9.61032 23.546 9.38778 23.2383 9.23153C22.9305 9.07528 22.5778 8.99716 22.18 8.99716C21.7776 8.99716 21.4248 9.08002 21.1218 9.24574C20.8188 9.40672 20.582 9.6411 20.4116 9.94886C20.2459 10.2566 20.163 10.6307 20.163 11.071H16.832C16.832 10.0814 17.0546 9.2268 17.4996 8.5071C17.9447 7.78741 18.5697 7.23343 19.3746 6.84517C20.1843 6.45218 21.1242 6.25568 22.1942 6.25568C23.2975 6.25568 24.2563 6.44034 25.0707 6.80966C25.8851 7.17898 26.5148 7.69508 26.9599 8.35795C27.4097 9.0161 27.6346 9.78078 27.6346 10.652C27.6346 11.206 27.5233 11.7552 27.3008 12.2997C27.0782 12.8442 26.6781 13.4455 26.1005 14.1037C25.5276 14.7618 24.7132 15.5502 23.6573 16.4688L21.9173 18.0739V18.1662H27.8121V21H17.0451Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1109",
    x1: 16.5,
    y1: 0,
    x2: 16.5,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#365FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#143880"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouble2);
export default __webpack_public_path__ + "static/media/double2.f91c805f4d7c83e554305bf4d9963ae0.svg";
export { ForwardRef as ReactComponent };